import type { SetActiveRequirementAction } from './action'

export const setActiveRequirementActionCreator = (
  payload: SetActiveRequirementAction['payload'],
): SetActiveRequirementAction => ({
  type: 'setActiveRequirement',
  payload,
})
